import { FormControl } from '@angular/forms';
var FcFilterTypeOutlinedSelectComponent = /** @class */ (function () {
    function FcFilterTypeOutlinedSelectComponent() {
    }
    return FcFilterTypeOutlinedSelectComponent;
}());
export { FcFilterTypeOutlinedSelectComponent };
